import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { byFilterKey } from '@utils/pageConfig/Predicates/SelectedFiltersPredicates';
import { FilterKeys, PageType } from '@utils/pageConfig/Types';

export const useFilters = (pageType: PageType, filterKey: FilterKeys) => {
  const { selectedFilters, appliedFilters } = usePageConfig();

  const selectedFiltersByPage = selectedFilters[pageType].selectedFilters;
  const appliedFilterByPage = appliedFilters[pageType].selectedFilters;

  const selectedFilterByFilterKey = selectedFiltersByPage.find(byFilterKey(filterKey));
  const appliedFilterByFilterKey = appliedFilterByPage.find(byFilterKey(filterKey));

  return {
    selectedFilter: selectedFilterByFilterKey?.options ?? [],
    appliedFilter: appliedFilterByFilterKey?.options ?? [],
    selectedFilterTitle: selectedFilterByFilterKey?.filterTitle ?? '',
    appliedFilterTitle: appliedFilterByFilterKey?.filterTitle ?? '',
  };
};
